import styles from "./home.module.scss"
import { useNavigate } from "react-router-dom"

// Overlay textures
import BorderVertical from "../../assets/images/textures/vertical.svg"
import BorderHoriz from "../../assets/images/textures/horizontal.svg"

// Card backgrounds
import RaceHub from "../../assets/images/backgrounds/race_hub.png"
import PitCrew from "../../assets/images/backgrounds/pit_crew.png"
import RB22 from "../../assets/images/backgrounds/rb22.png"
import RaceSupport from "../../assets/images/backgrounds/race_support.png"
import Background from "../../assets/images/backgrounds/background-redbull.png"

// Cosmos Componenets
import { CosmosTitle, CosmosText, CosmosIconLockFilled } from "@cosmos/web-react"

// Main entry page for the application
export default function Home() {
	// Setup an instance to the router navigator
	const navigate = useNavigate()

	return (
		<div
			className={styles.container}
			style={{ backgroundImage: `url("${Background}")` }}>
			{/* Borders */}
			<img
				src={BorderVertical}
				alt="Vertical Border"
				className={styles.vertical}
			/>
			<img
				src={BorderHoriz}
				alt="Horizontal Border"
				className={styles.horizontal}
			/>

			<div className={styles.cards}>
				<div
					className={styles.card}
					style={{ backgroundImage: `url("${RaceHub}")` }}
					onClick={() => navigate("/race-hub")}>
					<CosmosTitle size="x-large">RACE HUB</CosmosTitle>
				</div>
				<div
					className={styles.card}
					style={{ backgroundImage: `url("${PitCrew}")` }}
					onClick={() => navigate("/pit-crew")}>
					{/* <div className={styles.lockIcon}>
						<CosmosIconLockFilled />
					</div> */}
					<CosmosTitle size="x-large">PIT CREW</CosmosTitle>
					{/* <CosmosText
						className={styles.soon}
						size="medium">
						COMING SOON
					</CosmosText> */}
				</div>
				<div
					className={styles.card}
					style={{ backgroundImage: `url("${RaceSupport}")` }}
					onClick={() => navigate("/race-support")}>
					<CosmosTitle size="x-large">RACE SUPPORT</CosmosTitle>
				</div>
				<div
					className={`${styles.card}`}
					style={{ backgroundImage: `url("${RB22}")` }}
					onClick={() => navigate("/rb22")}>
					<CosmosTitle size="x-large">RB22</CosmosTitle>
				</div>
			</div>
		</div>
	)
}
